module.exports = __webpack_public_path__ + "static/media/clicking.fc4377b2.svg";